/**
 * Time units.
 */
export enum Time {
  Second = 1000,
  Minute = 60 * Second,
  Hour = 60 * Minute,
}
